module.exports = __webpack_public_path__ + "static/chooseFear-ac1bfbb5ebef1c64b74cfcb785c3db35.jpg";